<template>
<div class="pageEmailReset">
  <XR-head titleText="修改邮箱" :rightShow="true" ></XR-head>
  <mu-stepper :activeStep="activeStep" class="mobileResetSetup">
    <mu-step>
      <mu-step-label>
        验证
      </mu-step-label>
    </mu-step>
    <mu-step>
      <mu-step-label>
        绑定
      </mu-step-label>
    </mu-step>
    <mu-step>
      <mu-step-label>
        成功
      </mu-step-label>
    </mu-step>
  </mu-stepper>  
  <div class="mobileResetSetupContent">
    <p v-if="finished" class="finishedContent">
      恭喜您，已修改邮箱!<a href="javascript:;" @click="reset">点这里</a>可以继续修改
    </p>
    <template v-if="!finished">
      <p class="title">{{content}}</p>
      <mu-divider></mu-divider>
      <div class="mobileResetForm">
        <mu-row gutter class="emailRow">
          <mu-col width="100" tablet="100" desktop="33">
            <mu-text-field label="旧邮箱" icon=":fa fa-envelope-o" labelFloat :maxLength="25" v-if="activeStep==0?true:false" :disabled="activeStep==0?true:false" fullWidth v-model="oldEmailInfo.email" />
            <mu-text-field label="新邮箱" icon=":fa fa-envelope-o" labelFloat :maxLength="25" v-if="activeStep==1?true:false" fullWidth v-model="newEmailInfo.email" />
          </mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="70" tablet="75" desktop="33">
            <mu-text-field label="验证码" helpText="点击右侧按钮获取" icon=":fa fa-key" v-if="activeStep==0?true:false" labelFloat fullWidth v-model="oldEmailInfo.code" />
            <mu-text-field label="验证码" helpText="点击右侧按钮获取" icon=":fa fa-key" v-if="activeStep==1?true:false" labelFloat fullWidth v-model="newEmailInfo.code" />
          </mu-col>
          <mu-col width="30" tablet="25" desktop="33">      
            <mu-raised-button :label="smsBtnText" class="sms-button" @click="getEmailCode()" secondary/>   
          </mu-col>
        </mu-row>
      </div>
      <div class="resetButton">
        <mu-raised-button class="UpButton" label="上一步" :disabled="activeStep === 0" @click="handlePrev"/>
        <mu-raised-button class="LowButton" :label="activeStep === 2 ? '完成' : '下一步'" primary @click="handleNext"/>
      </div>
    </template>
  </div>
  <XR-toast ref="XRtoast"></XR-toast>
</div>
</template>


<script>
export default {
  data () {
    return {
      activeStep: 0,
      oldEmailInfo:{
        email:'',
        code: '',
        isTestEmail:false
      },
      newEmailInfo:{
        email: '',
        code: ''
      },
      smsBtnText:'验证码',
      oldInteverl:0,
      newInteverl:0
    }
  },
  computed: {
    content () {
      let message = ''
      switch (this.activeStep) {
        case 0:
          message = '请验证您的旧邮箱'
          break
        case 1:
          message = '请绑定您的新邮箱'
          break
        default:
          message = '请重新开始'
          break
      }
      return message
    },
    finished () {
      return this.activeStep > 1
    }
  },
  mounted(){
    this.getMemberInfo()
  },
  methods: {
    getMemberInfo(){           
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false          
          ths.$refs.XRtoast.hide()
          ths.oldEmailInfo.email=res.Data.email
          ths.oldEmailInfo.isTestEmail = res.Data.IsTestEmail
        }
      });      
    },
    handleNext () {         
      switch (this.activeStep) {
        case 0:
          this.validateCode()
          break
        case 1:
          this.bindNewEmail()
          break
        default:
          break
      }
    },
    handlePrev () {
      this.activeStep--
    },
    reset () {
      this.activeStep = 0
      this.smsBtnText = '验证码'
      clearInterval(this.oldInteverl)
    },
    getEmailCode: function(){      
      switch (this.activeStep) {
        case 0:
          this.sendEmailCode()
          break
        case 1:
          this.sendNewEmailCode()
          break
        default:
          break
      }
    },
    sendEmailCode:function(){
      this.$refs.XRtoast.load()
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/SendModifyEmailCode"
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{          
          ths.smsBtnText = res.Data * 60;
          ths.oldInteverl = setInterval(function(){
            if(ths.smsBtnText >0){
              ths.smsBtnText--
            }else{
              ths.smsBtnText = '验证码'
              clearInterval(oldInteverl)
            }
          }, 1000)  
        }
      });
    },
    validateCode: function(){
      if(!this.oldEmailInfo.code){
        this.$refs.XRtoast.failed('请输入验证码', true)
        return
      }
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/ValidateModifyEmailCode",
        JSON.stringify(this.oldEmailInfo)
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{          
          ths.activeStep++
          ths.smsBtnText = '验证码'
        }
      });
    },
    sendNewEmailCode:function(){
      this.$refs.XRtoast.load()
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/SendModifyEmailNewCode",
        JSON.stringify(this.newEmailInfo)
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{          
          ths.smsBtnText = res.Data * 60;
          ths.newInteverl = setInterval(function(){
            if(ths.smsBtnText >0){
              ths.smsBtnText--
            }else{
              ths.smsBtnText = '验证码'
              clearInterval(ths.newInteverl)
            }
          }, 1000)  
        }
      });
    },    
    bindNewEmail: function(){
      if(!this.newEmailInfo.code){
        this.$refs.XRtoast.failed('请输入验证码', true)
        return
      }
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/BindModifyEmail",
        JSON.stringify(this.newEmailInfo)
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.activeStep++

          //window.reload()
          ths.oldEmailInfo.email =''
          ths.oldEmailInfo.code=''
          ths.newEmailInfo.email=''
          ths.newEmailInfo.code=''
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getMemberInfo()
        }
      });
    },
  }
}
</script>

<style>
#app .pageEmailReset {
  width: 100%;
  margin: auto;
}

.pageEmailReset .mobileResetSetup{
  width: 100%;
  padding: 0 10%;
  background: white;
}

.pageEmailReset .mobileResetSetupContent{
  margin-top: 10px;
  background: white;
  width: 100%;
}
.pageEmailReset .mobileResetSetupContent p.title{
  text-align: center;
  padding: 30px 0;
}
.pageEmailReset .mobileResetForm{
  margin-top: 10px;
  padding: 10px 0 40px;
  background: white;
  width: 100%;
}
.pageEmailReset .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}


.pageEmailReset .resetButton {
  text-align: center;
  padding: 30px 0;
  background: #F0F2F5;
}

.pageEmailReset .UpButton {
  margin-top: 12px;
  margin-right: 12px;
}
.pageEmailReset .LowButton {
  margin-top: 12px;
  margin-right: 12px;
}

.pageEmailReset .finishedContent{
  padding: 40px 0;
  text-align: center;
}

.pageEmailReset .emailRow{
  padding-right: 10px;
}
</style>




// WEBPACK FOOTER //
// src/pages/usercenter/emailChangeReset.vue